import styled from "styled-components";
import { getMarginStyle, getPaddingStyle } from "core/styles/paddingMarginStyle";
import { Props } from ".";

export const Img = styled.img<Props>`
  width: ${({ size, width }) => (size || width) + "px"};
  height: ${({ size, height }) => (size || height) + "px"};
  margin-right: ${({ marginRight }) => marginRight};
  border-radius: ${({ round }) => (round ? "50%" : "0px")};
  position: ${({ position }) => (position ? position : "relative")};
  object-fit: ${({ objectFit }) => objectFit ?? "unset"};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "unset")};

  ${getPaddingStyle}
  ${getMarginStyle}
`;
